import { lazy } from 'react';

export default {
  path: 'resetpassword/:user/:uniquetoken',
  title: 'Reset Password',
  component: lazy(() => import('./index'))
};
